export const AppConfig = {};
